'use client';

import { useRef } from 'react';

import { useSymbols } from '@flipster/features/src/shared/symbol/use-symbols';
import { Button } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { center, grid } from '@flipster/styled-system/patterns';
import { truncateUnit } from '@flipster/utils/num';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import { maxWStyles, sectionSmallHeadingStyles } from '@web/app/[locale]/(web)/_main-page/_styles';
import { useMainPageIntersectionSegment } from '@web/app/[locale]/(web)/_main-page/hooks/useIntersectionSegment';
import { MarketCarouselType } from '@web/app/[locale]/_sorted-top-market/constants';

import { SortedTopMarket } from '../../../_sorted-top-market';

const Products = () => {
  const { totalSymbol } = useSymbols();
  const intersectionRef = useRef<HTMLHeadingElement>(null);
  useMainPageIntersectionSegment(intersectionRef, 'selections listed');

  return (
    <section className={css(maxWStyles, { pt: { base: 48, tablet: 64 } }, { pb: { base: 48, tablet: 96 } })}>
      <h2
        ref={intersectionRef}
        className={css(sectionSmallHeadingStyles)}
      >{`${truncateUnit(totalSymbol)} selections listed`}</h2>
      <div
        className={grid({
          gap: 16,
          mb: { base: 32, tablet: 40 },
          tablet: { gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))' },
          h: 322,
          overflow: 'hidden',
        })}
      >
        {(['newListings', 'priceChange24h', 'volume'] satisfies MarketCarouselType[]).map((id) => (
          <SortedTopMarket carouselId={id} key={`main-market-${id}`} productType='perpetual' />
        ))}
      </div>
      <div className={center()}>
        <Button
          hierarchy='primary'
          color='accent'
          size='large'
          as='a'
          href='/market'
          onClick={() => segment.track(MainEvent.MainPageAllProductsClick)}
          label='View all products'
          css={{ w: 172 }}
        />
      </div>
    </section>
  );
};

export default Products;
